var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatasearchLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74.674,
    height: 60.674,
    viewBox: "0 0 74.674 74.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5825",
    d: "M0-682.665H74.674v74.674H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g5811",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5813",
    transform: "translate(33.642 -624.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5815",
    d: "M0,0V8.131",
    transform: "translate(0)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5817",
    transform: "translate(25.048 -624.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5819",
    d: "M0,0V8.131",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5821",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5823",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5829",
    transform: "translate(29.345 58.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5831",
    d: "M0,0V12.765",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g5833",
    transform: "translate(57.975 -656.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5835",
    d: "M0,0H8.131",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5837",
    transform: "translate(57.975 -647.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5839",
    d: "M0,0H8.131",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5841",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5843",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5849",
    transform: "translate(58.3 30.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5851",
    d: "M0,0H13.02",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5853",
    transform: "translate(52.236 52.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5855",
    d: "M-163.028-112.647l1.065,1.065a.875.875,0,0,1,0,1.238l-4.95,4.95a.875.875,0,0,1-1.238,0L-182.8-120.038a.875.875,0,0,1,0-1.237l4.95-4.95a.875.875,0,0,1,1.238,0l10.281,10.281",
    transform: "translate(183.052 126.482)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5857",
    transform: "translate(48.231 48.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5859",
    d: "M-25.144,0l5.194,5.2-3.094,3.094L-28.232,3.1",
    transform: "translate(28.232)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5861",
    transform: "translate(55.225 55.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5863",
    d: "M-75.571-25.19-81.759-19-84.853-22.1l6.188-6.188Z",
    transform: "translate(84.853 28.284)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5865",
    transform: "translate(1.094 1.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5867",
    d: "M-413.22-87.952a28.319,28.319,0,0,1,6.129,17.638,28.441,28.441,0,0,1-28.44,28.44,28.44,28.44,0,0,1-28.44-28.44,28.44,28.44,0,0,1,28.44-28.44,28.337,28.337,0,0,1,19.123,7.388",
    transform: "translate(463.972 98.754)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5869",
    transform: "translate(5.468 5.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5871",
    d: "M-49.263-326.212a23.448,23.448,0,0,1-6.049-16,24.184,24.184,0,0,1,24.065-24.065A24.092,24.092,0,0,1-7.182-342.213a24.092,24.092,0,0,1-24.065,24.065,24.65,24.65,0,0,1-14.576-4.916",
    transform: "translate(55.314 366.278)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5873",
    transform: "translate(16.773 16.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5875",
    d: "M0-4.75a.583.583,0,0,1,.583-.583H8.168a.583.583,0,0,1,.583.583V8.085H0Z",
    transform: "translate(0 5.333)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5877",
    transform: "translate(34.274 22.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5879",
    d: "M-71.249-64.124H-80v-7.292A.583.583,0,0,1-79.416-72h7.584a.583.583,0,0,1,.583.583Z",
    transform: "translate(80 72)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5881",
    transform: "translate(25.523 11.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5883",
    d: "M-71.249-154.373H-80V-172.75a.583.583,0,0,1,.583-.583h7.584a.583.583,0,0,1,.583.583Z",
    transform: "translate(80 173.333)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5885",
    transform: "translate(14.215 30.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5887",
    d: "M0,0H31.368",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5889",
    transform: "translate(17.917 34.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5891",
    d: "M0-54.352H5.778l2.459-4.4,3.24,9.184,4.248-11.456,2.612,6.676h5.9",
    transform: "translate(0 61.028)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasearchLarge);
export default __webpack_public_path__ + "static/media/datasearch_large.db164a4a46ebdb4309b8c93c3b895a69.svg";
export { ForwardRef as ReactComponent };